import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import fr from './locales/fr.json';
import en from './locales/en.json';
import es from './locales/es.json';
import de from './locales/de.json';
import it from './locales/it.json';
import pt from './locales/pt.json';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  es: { translation: es },
  de: { translation: de },
  it: { translation: it },
  pt: { translation: pt }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'es', 'de', 'it', 'pt'],
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

// For native platforms, detect language on app start
const detectNativeLanguage = async () => {
  try {
    const { Capacitor } = await import('@capacitor/core');
    if (Capacitor.isNativePlatform()) {
      const { Device } = await import('@capacitor/device');
      const info = await Device.getLanguageCode();
      const lang = info.value.split('-')[0];
      
      // Only change if no saved preference and language is supported
      const savedLang = localStorage.getItem('i18nextLng');
      if (!savedLang && ['fr', 'en', 'es', 'de', 'it', 'pt'].includes(lang)) {
        i18n.changeLanguage(lang);
      }
    }
  } catch (e) {
    console.log('Native language detection not available:', e.message);
  }
};

// Run detection after a short delay to ensure app is loaded
setTimeout(detectNativeLanguage, 100);

export default i18n;
